<div class="{{_theme()}}">
  @if (_theme() === 'light') {
    <img class="loading" src="assets/svg/animated/loading.svg">
  } @else {
    <img class="loading dark" src="https://4d-icons.s3.eu-west-2.amazonaws.com/web/4d_109x90.png">
    @if (_message()) {
      <p [style.font-size.px]="_px()">{{_message()}}</p>
    }
  }

</div>
